import IhrTextProps from "components/HrText/IHrTextProps";

import "./HrText.css";

const HrText: React.FC<IhrTextProps> = ({ text }) => {
	return (
		<div className="hr-text">
			<span>{text}</span>
		</div>
	);
};

export default HrText;
